/**
 * i18n Configuration
 * 
 * Setup for internationalization with i18next
 * Supports: English, Français, Deutsch, Español
 * Features: Language persistence, locale-specific formatting, fallback to English
 */

import en from '../locales/en.json';
import fr from '../locales/fr.json';
import de from '../locales/de.json';
import es from '../locales/es.json';

// Define supported languages
export const SUPPORTED_LANGUAGES = {
  en: { name: 'English', flag: '🇬🇧' },
  fr: { name: 'Français', flag: '🇫🇷' },
  de: { name: 'Deutsch', flag: '🇩🇪' },
  es: { name: 'Español', flag: '🇪🇸' },
};

// Translation resources
export const resources = {
  en: { translation: en },
  fr: { translation: fr },
  de: { translation: de },
  es: { translation: es },
};

// Get default language from browser or localStorage
export const getDefaultLanguage = () => {
  // Check localStorage first
  const savedLanguage = localStorage.getItem('i18nextLanguage');
  if (savedLanguage && SUPPORTED_LANGUAGES[savedLanguage]) {
    return savedLanguage;
  }

  // Check browser language
  const browserLanguage = navigator.language.split('-')[0];
  if (SUPPORTED_LANGUAGES[browserLanguage]) {
    return browserLanguage;
  }

  // Default to English
  return 'en';
};

// i18next configuration
export const i18nConfig = {
  resources,
  lng: getDefaultLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
};

export default i18nConfig;
